export const en = {
    show_email: 'Show email',
    hide_email: 'Hide email',
    failed_to_receive_email: 'Failed to receive employee email. Try again later',
};
